import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';
import Card from '../components/Card';
import SectionTitle from '../components/SectionTitle';

const HomePage = () => {
  return (
    <div className="page">
      <Header />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-circle"></div>
        <div className="hero-content">
          <h1>Empowering Patients with AI-Driven Insights</h1>
          <p>Prepare smarter for your next doctor visit — powered by AI that understands your health needs.</p>
          <div>
            <Button
              variant="primary"
              size="lg"
              to="/priorv-form"
              className="hover-scale"
            >
              Prepare for Your Next Doctor Visit
            </Button>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products">
        <div className="container">
          <SectionTitle
            title="Our Products"
            subtitle="Discover how Patients Empowered transforms healthcare for patients and providers"
            centered={true}
          />

          <div className="products-divider">
            <span className="products-divider-line"></span>
            <span className="products-divider-icon">✦</span>
            <span className="products-divider-line"></span>
          </div>

          <div className="products-grid">
            <Card className="product-card animate-fade-in-up delay-100" hover={true}>
              <div className="product-card-content">
                <div className="product-icon product-icon-patient">
                  <span className="product-emoji">🧭</span>
                </div>
                <div className="product-content">
                  <h3 className="product-title">Patients Empowered Coach</h3>
                  <p className="product-description">AI health companion for patients that prepares for appointments, explains medical conditions, and provides continuous guidance</p>
                  <div className="product-action">
                    <Button variant="secondary" size="sm" to="/about">Learn More</Button>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="product-card animate-fade-in-up delay-200" hover={true}>
              <div className="product-card-content">
                <div className="product-icon product-icon-provider">
                  <span className="product-emoji">🏥</span>
                </div>
                <div className="product-content">
                  <h3 className="product-title">Patients Empowered Practice</h3>
                  <p className="product-description">AI-powered support for healthcare providers with clinical documentation, decision support, and patient insights</p>
                  <div className="product-action">
                    <Button variant="secondary" size="sm" to="/about">Learn More</Button>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <SectionTitle
            title="How It Works"
            subtitle="Our AI platform transforms healthcare delivery through integrated solutions"
            centered={true}
          />

          <div className="steps-grid">
            <Card className="step-card animate-fade-in-left delay-100">
              <div className="step-icon">1️⃣</div>
              <h3 className="step-title">Input Your Symptoms</h3>
              <p className="step-description">Share your health concerns and symptoms through our comprehensive form</p>
              <div className="mt-3">
                <Button variant="secondary" size="sm" to="/priorv-form">Start Now</Button>
              </div>
            </Card>

            <Card className="step-card animate-fade-in-up delay-200">
              <div className="step-icon">2️⃣</div>
              <h3 className="step-title">AI Analysis</h3>
              <p className="step-description">Our AI analyzes your information and asks relevant follow-up questions</p>
              <div className="mt-3">
                <Button variant="secondary" size="sm" to="/about">Learn More</Button>
              </div>
            </Card>

            <Card className="step-card animate-fade-in-right delay-300">
              <div className="step-icon">3️⃣</div>
              <h3 className="step-title">Get Your Report</h3>
              <p className="step-description">Download your personalized report to bring to your doctor's appointment</p>
              <div className="mt-3">
                <Button variant="secondary" size="sm" to="/guides">View Samples</Button>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
{/* TESTIMONIALS SECTION REMOVED
        <div className="container">
          <SectionTitle
            title="What Our Users Say"
            subtitle="Read how Patients Empowered creates the healthcare experience users have always wanted"
            centered={true}
          />

          <div className="grid grid-cols-1 grid-md-cols-2 grid-lg-cols-3 gap-lg">
            <Card className="animate-fade-in-up delay-100">
              <div className="text-center mb-3">
                <img src="/images/testimonials/photo-avatar1.jpg" alt="Sarah T." className="rounded-circle mx-auto" style={{ width: '80px', height: '80px' }} />
              </div>
              <p className="mb-3 text-center">"Patients Empowered helped me organize my thoughts before my doctor's appointment. I felt much more prepared and confident."</p>
              <div className="text-center">
                <strong>Sarah T.</strong>
                <p className="text-muted text-sm">Patient, 42</p>
              </div>
            </Card>

            <Card className="animate-fade-in-up delay-200">
              <div className="text-center mb-3">
                <img src="/images/testimonials/photo-avatar2.jpg" alt="Michael R." className="rounded-circle mx-auto" style={{ width: '80px', height: '80px' }} />
              </div>
              <p className="mb-3 text-center">"The PDF report was incredibly helpful. My doctor appreciated how organized the information was."</p>
              <div className="text-center">
                <strong>Michael R.</strong>
                <p className="text-muted text-sm">Patient, 58</p>
              </div>
            </Card>

            <Card className="animate-fade-in-up delay-300">
              <div className="text-center mb-3">
                <img src="/images/testimonials/photo-avatar3.jpg" alt="Jessica L." className="rounded-circle mx-auto" style={{ width: '80px', height: '80px' }} />
              </div>
              <p className="mb-3 text-center">"I've always struggled to remember everything I wanted to discuss with my doctor. This solved that problem completely."</p>
              <div className="text-center">
                <strong>Jessica L.</strong>
                <p className="text-muted text-sm">Patient, 46</p>
              </div>
            </Card>
          </div>
        </div>
END TESTIMONIALS SECTION */}

      {/* Call to Action Section */}
      <section className="section" style={{ backgroundColor: 'var(--color-primary-light)' }}>
        <div className="container text-center">
          <h2 className="mb-3 animate-fade-in">Ready to Take Control of Your Healthcare?</h2>
          <p className="mb-4 animate-fade-in-up delay-100" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Start preparing for your next doctor visit today and experience the difference that proper preparation can make.
          </p>
          <div className="animate-fade-in-up delay-200">
            <Button
              variant="primary"
              size="lg"
              to="/priorv-form"
              className="hover-scale"
            >
              Get Started Now
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;